/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles.js";
import MainHeader from "../../../../Shared/components/Header/index.js";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard.js";
import { Row, Col, Image } from "antd";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import { TextField, Box, Typography } from "@mui/material";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer.js";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import clsx from "clsx";
import usePrevious from "../../../../Shared/components/Previous/index.js";
import crudActions from "../../../../CRUD/redux/actions.js";
import { checkViewPermission, checkComponentPermission } from '../../../../../helpers/utilities.js';
import { ListTable } from './ListTable.js'
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';
import { customNumberValidation } from "../../../../../helpers/validation.js";


const ActivityPrefixCounter = (props) => {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { editDetails, editError, getList, getData } = useSelector(state => state.crudReducer);
    const { businessDetails } = useSelector(state => state.homeReducer);

    const { history } = props;
    const [visible, setVisible] = useState(false);

    const timeoutRef = useRef(null);
    const [iconAnimation, setIconAnimation] = useState(false);
    const [skip, setSkip] = useState(0);
    const limit = 25;
    const [error, setError] = useState({});
    const [form, setForm] = useState({});
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [search, setSearch] = useState('');
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const prevSearch = usePrevious(search);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const dispatch = useDispatch();

    // const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {

    // }

    const handleOpen = () => {
        setVisible(true);
        setForm({});
    };

    const handleClose = () => {
        setVisible(false);
        setForm({});
    };

    useEffect(() => {
        if (roleManagement !== '' && checkViewPermission('Activity Prefix Counter', history, 'Admin')) {
            loadTasks();
        }
    }, [roleManagement]);

    const loadTasks = () => {
        dispatchFilter(sortBy, sortOrder);
    }

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }

    const onView = (data, v) => {
        handleOpen();
        setForm(data);
    }

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            dispatchFilter(sortBy, sortOrder);
            handleClose();
            toast.dismiss();
            toast(editDetails);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            toast.dismiss();
            toast(editError.error.message);
        }
    }, [editDetails, editError]);


    useEffect(() => {
        if ((prevSearch !== undefined && search && search?.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    const prevGetData = usePrevious(getData); useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData?.length > 0) {
                    setLoadMore(true);
                    if (getData?.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }

        let filter = { ["and"]: [] };
        let or = { ["or"]: [] };

        if (search !== '') {
            or['or'].push({ id: { like: '%' + search.trim() + '%' } });
        }

        filter['and'].push(or);
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'globalActivityCounters',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        let emptyCounter = customNumberValidation('Counter', form?.counter);
        if (emptyCounter?.isValid) {
            dispatch({
                type: crudActions.EDIT_DETAILS_START,
                url: "globalActivityCounters",
                title: "Global Activity Prefixes Counter",
                id: form?.id,
                details: { counter: form?.counter }
            });
        } else {
            setError({
                ...error,
                counter: emptyCounter?.errors
            })
        }
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props} img={SettingsImg} title={'Admin'} links={[{ 'label': 'Younote Admin', 'link': '/younote-admin' }, { 'label': 'Global Activity Prefix Counter', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Global Activity Prefix Counter'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Global Activity Prefix Counter', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                className={classes.comInput}
                                                required
                                                variant={'standard'}
                                                fullWidth
                                                onChange={(e) => setSearch(e.target.value)}
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                        </div>
                                    }
                                </Col>
                            </Row>
                            <ListTable
                                businessDetails={businessDetails}
                                onView={(data, v) => onView(data, v)}
                                onEdit={(data, v) => onView(data, v)}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                roleManagement={roleManagement}
                                loadMoreTask={() => loadMoreTask()}
                                sortOrder={sortOrder} sortBy={sortBy}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
                <PrimaryDrawer
                    anchor={'right'}
                    open={visible}
                    variant={'temporary'}
                    handleClose={() => handleClose()}
                    title={`View Global Activity Counter`}
                    width={"495px"}
                    className={clsx(classes.closeBackGround, classes.width100P)}
                    component={
                        <Box
                            className={clsx(classes.customForm, classes.removeUnderline)}
                            component="form"
                            autoComplete="off"
                            onSubmit={(e) => handleSubmit(e)}>
                            <div className={classes.customFormFlex}>
                                <Row type="flex" gutter={40}>
                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Module</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.activityPrefix?.feature?.module?.module ?? '---'}</Typography>
                                    </Col>
                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, classes.feature, 'MuiInputLabel-shrink', classes.fonSize13)}>Feature</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.activityPrefix?.feature?.featureName ?? '---'}</Typography>
                                    </Col>
                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Business Prefix</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.prefix}</Typography>
                                    </Col>
                                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                                        <Typography variant={'subtitle1'} className={clsx(classes.margin20t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Counter</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{`${form?.prefix}${form?.counter}`}</Typography>
                                    </Col>
                                </Row>
                            </div>
                        </Box>
                    }
                />
            </div>
            {/* <CustomModal
                title={'Reset Feature'}
                visible={resetModal}
                onClose={() => setResetModal(false)}
                text={`Do you want to reset ${form?.activityPrefix?.feature?.featureName} Number`}
                yesButton={'Yes'}
                noButton={'Cancel'}
                onOpen={() => handleReset()}
                loading={editLoader}
            /> */}
        </React.Fragment>
    )
}
export default ActivityPrefixCounter